import { useState } from "react";
import Button from "react-bootstrap/Button";

const Cancel = ({ onClick, title = "Cancel", variant }) => {
  const [error, setError] = useState("");

  const handleClick = (onClickFunction) => {
    try {
      onClickFunction();
    } catch (err) {
      setError(err);
    }
  };

  if (error) {
    throw new Error(error);
  }
  return (
    <Button
      // https://github.com/redux-form/redux-form/issues/860#issuecomment-625254444
      onMouseDown={(e) => e.preventDefault()}
      onClick={() => handleClick(onClick)}
      variant={variant || "light"}
      size="sm"
    >
      {title}
    </Button>
  );
};
export default Cancel;
